/** @module Enums */ /** typedoc */
// The user interaction sources should represent a position in the screen and not refer to a section or page in the app.
//
// ex:
//      ReleaseTitle    =>  BAD
//      RowTitle        =>  GOOD
var UserInteractionSourceEnum;
(function (UserInteractionSourceEnum) {
    UserInteractionSourceEnum["TableButton"] = "TableButton";
    UserInteractionSourceEnum["RowButton"] = "RowButton";
    UserInteractionSourceEnum["RightClick"] = "RightClick";
    UserInteractionSourceEnum["ItemMenu"] = "ItemMenu";
    UserInteractionSourceEnum["SidebarButton"] = "SidebarButton";
    UserInteractionSourceEnum["BannerButton"] = "BannerButton";
    UserInteractionSourceEnum["Widget"] = "Widget";
    UserInteractionSourceEnum["EmptyStateButton"] = "EmptyStateButton";
    UserInteractionSourceEnum["Notification"] = "Notification";
    UserInteractionSourceEnum["RowCover"] = "RowCover";
    UserInteractionSourceEnum["RowTitle"] = "RowTitle";
})(UserInteractionSourceEnum || (UserInteractionSourceEnum = {}));

export { UserInteractionSourceEnum };
